import { Component, OnInit, computed, inject } from '@angular/core';
import { Subject } from 'rxjs';
import { products } from '../../../../shared/data/product-data';
import { BlueOcean } from '../../../../shared/models/blueocean-product';
import { PowerBiApi } from '../../models/power-bi-models';
import { ReportIconComponent } from '../report-icon/report-icon.component';
import { ApplicationState } from '../../../../shared/state/application-state.service';
import { PowerBiState } from '../../state/power-bi-state.service';

@Component({
  selector: 'app-reports-icon-list',
  templateUrl: './reports-icon-list.component.html',
})
export class ReportsIconListComponent  {

  applicationStateService = inject(ApplicationState);
  powerBiState = inject(PowerBiState);

  private readonly products: BlueOcean.Product[] = products;

  currentReports = this.powerBiState.reports;
  activeReport = this.powerBiState.selectedReport;

  readonly availableProducts = computed(() => {
    const reports = this.currentReports();
    const p = this.products.filter(product => reports.some(report => report.name === product.name));
    console.log(p);
    return p;
  });

  constructor() { }

  setActiveReport(reportName: string) {
    this.powerBiState.selectReportByName(reportName);
  }
}
